/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "88")
  

// 接口文档

  
    
export interface IAPI65794ResListItem {
  
  /** 用户id */
  userId?: string;
  
  /** 花名 */
  userName?: string;
  
  /** 真实姓名 */
  realName?: string;
  
  /** 头像 */
  headIconUrl?: string;
  
  /** 职位 */
  position?: string;
  
  /** 主部门id */
  orgId?: string;
  
  /** 主部门全路径 */
  orgPathDesc?: string;
  
  /** 手机号 */
  userPhone?: string;
  
};
    
  



export interface API65794Req {
  
  /** (List<String>) */
  orgIds: string;
    
  /** 带查询的层级(Integer) */
  subLevel?: string;
    
};



export interface API65794Res {
  /** T  */
  list?: IAPI65794ResListItem[];
  
};


// 接口函数 65794 通过部门id集合查询下级用户

export interface IUseGetAPI65794Return {
  /** 通过部门id集合查询下级用户: 接口请求状态 */
  isAPI65794Loading: boolean;
  /** 通过部门id集合查询下级用户: 接口请求返回数据 */
  dataAPI65794: API65794Res;
  /**  通过部门id集合查询下级用户: 接口数据请求方法 */
  fetchAPI65794Data: (inputs: API65794Req, config?: YWRequestConfig) => Promise<API65794Res>;
  /** 通过部门id集合查询下级用户: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI65794 = ():IUseGetAPI65794Return => {
  let isMount = true;
  const [isAPI65794Loading, setIsAPI65794Loading] = useState(false);
  const [dataAPI65794, setDataAPI65794] = useState<API65794Res>({} as API65794Res);
  const requestUrl = `${basePath}/ywwl-admin/selector/listOrgUser/v2`;

  const fetchAPI65794Data = async (inputs: API65794Req, config?: YWRequestConfig): Promise<API65794Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API65794Req>) || {}) as API65794Req;
    
  
    if ( isMount ) {
      setIsAPI65794Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API65794Res>(`${basePath}/ywwl-admin/selector/listOrgUser/v2?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI65794(res || {} as API65794Res);
        setIsAPI65794Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI65794Loading(false);
      }
      return false as unknown as API65794Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI65794Loading,
    dataAPI65794,
    fetchAPI65794Data,
    requestUrl,
  }
}

